import React from "react";
import "./DropdownMenu.scss";
class DropdownMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: {},
    };
  }

  getMenuItemTitle = (menuItem, index, depthLevel) => {
    return menuItem.title;
  };

  getMenuItem = (menuItem, depthLevel, index) => {
    let title = this.getMenuItemTitle(menuItem, index, depthLevel);

    if (menuItem.submenu && menuItem.submenu.length > 0) {
      return (
        <li
          key={menuItem.itemKey}
          className={
            this.state.menuOpen[menuItem.itemKey] && this.props.open
              ? "multi active"
              : "multi"
          }
          onMouseEnter={() => this.toggleBaseMenu(menuItem.itemKey, true)}
          onMouseLeave={() => this.toggleBaseMenu(menuItem.itemKey, false)}
        >
          {title}
          {this.props.open && (
            <DropdownMenu
              open={this.props.open}
              topKey={this.props.topKey}
              onClick={this.props.onClick}
              config={menuItem.submenu}
              submenu={true}
            />
          )}
        </li>
      );
    } else {
      return (
        <li
          key={menuItem.itemKey}
          className="multi"
          onClick={(e) => this.props.onClick(menuItem)}
        >
          {title}
        </li>
      );
    }
  };
  toggleBaseMenu = (itemKey, value) => {
    // event.stopPropagation();
    if (itemKey === this.props.topKey) {
      if (value) this.props.onOpen();
      else this.props.onClose();
    }
    this.setState({
      menuOpen: {
        [itemKey]: value,
      },
    });
  };

  render = () => {
    let { config } = this.props;
    let options = [];
    config.map((item, index) => {
      options.push(this.getMenuItem(item, 0, index));
    });

    if (this.props.submenu && this.props.submenu === true)
      return <ul>{options}</ul>;

    return (
      <ul className="dropdown-menu-custom dropdown-menu-multilevel">
        {options}
      </ul>
    );
  };
}
export default DropdownMenu;
